import ReduxToolkit, { createSlice } from '@reduxjs/toolkit';

const NAME = 'bypass';

export type ValueType = boolean;

const initialState: ValueType = false;

const setAction: ReduxToolkit.CaseReducer<
	ValueType,
	ReduxToolkit.PayloadAction<ValueType>
> = (state, action) => {
	return action.payload;
};

export const bypassSlice = createSlice({
	name: NAME,
	initialState,
	reducers: {
		setBypass: setAction,
	},
});
